import './index.css'
import { Theme } from '@radix-ui/themes'
import cn from 'clsx'
import upperFirst from 'lodash/upperFirst'
import * as React from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import type { State } from 'types/redux'
import {
  campaignListCancelCreating,
  campaignListCreate,
  campaignListModalUpdate,
} from '@disco/state-management/actions/campaign-list-actions'
import DocumentHeadTags from 'components/document-head-tags'
import { Box } from 'components/ds'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import Heading from 'components/ui/heading'
import TextField from 'components/ui/text-field'
import modalStyles from 'components/utils/modalStyles'

function mapStateToProps(state: State) {
  return {
    modal: state.emailCampaigns.newCampaignModal,
  }
}

const mapDispatchToProps = {
  campaignListCancelCreating,
  campaignListModalUpdate,
  campaignListCreate,
}
const BRIEFING_ENABLED = false

class NewCampaignModal extends React.Component<{
  modal: State['emailCampaigns']['newCampaignModal']
  campaignListCancelCreating: typeof campaignListCancelCreating
  campaignListModalUpdate: typeof campaignListModalUpdate
  campaignListCreate: typeof campaignListCreate
}> {
  _nameRef: HTMLInputElement | null | undefined
  _handleChangeType = (type: 'briefing' | 'campaign') => {
    this.props.campaignListModalUpdate({
      type,
    })
  }
  _onClose = () => {
    this.props.campaignListCancelCreating()
  }
  _handleSubmit = () => {
    if (!this._nameRef) return
    let name = this._nameRef.value
    name = name.trim()
    const campaign = this.props.modal.campaign
    if (!campaign) return
    this.props.campaignListCreate({
      name,
      type: campaign.type,
    })
  }

  render() {
    const {
      modal: { visible, campaign },
    } = this.props
    if (!visible || !campaign) return null
    const c = campaign
    const type = 'email' // c.type

    return (
      <Modal isOpen style={modalStyles} onRequestClose={this._onClose}>
        <Theme>
          <DocumentHeadTags title={`New ${type} | DISCO`} />
          <div className="modal-width--400">
            <Heading>New {type}</Heading>
            {BRIEFING_ENABLED && (
              <Box mb="4">
                <Button
                  className={cn('NewCampaignModal_Link', {
                    active: c.type === 'briefing',
                  })}
                  onClick={() => this._handleChangeType('briefing')}
                  caption="Briefing"
                />
                <Button
                  className={cn('NewCampaignModal_Link', {
                    active: c.type === 'campaign',
                  })}
                  onClick={() => this._handleChangeType('campaign')}
                  caption="Email campaign"
                />
              </Box>
            )}
            <TextField
              label={`${upperFirst(type)} name`}
              inputRef={n => {
                this._nameRef = n
              }}
            />
            <div className="Form_ButtonsContainer separated-small">
              <ButtonContainer>
                <Button
                  appearance="primary"
                  caption="Begin"
                  progressCaption="Creating"
                  progressIndicator={c.saving}
                  onClick={this._handleSubmit}
                />
              </ButtonContainer>
            </div>
          </div>
        </Theme>
      </Modal>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewCampaignModal) as any
